import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import { Languages } from "src/SDC_apis/data/LanguageData";
import { AppState } from "src/store/Store";
import i18n from "src/utils/i18n";


const BlankLayout = () => {
  const customizer = useSelector((state: AppState) => state.customizer);
  const currentLang = Languages.find((_lang) => _lang.value === customizer.isLanguage) || Languages[0];

  useEffect(() => {
    i18n.changeLanguage(customizer.isLanguage);
  }, [currentLang]);
  

  return (
    <>
      <Helmet>
        <link rel="icon" href="/landingpage/images/SDCLogo.svg" />
      </Helmet>
      <Outlet />
    </>
  )
}

export default BlankLayout;
